// extracted by mini-css-extract-plugin
module.exports = {"hero":"Hero_hero__kzpph","quote":"Hero_quote__1HsIz"};